import React from "react";
import { PageHeader } from "./PageHeader";

export const RegistrationFee = props => {
  return (
    <React.Fragment>
      <PageHeader title="Terminy i opłaty" />
      <div className="content-wrapper">
        <div className="main-content registration-fee">
          <h2>Ważne daty i terminy</h2>
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12">
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th>Data</th>
                            <th></th>
                            <th>Termin</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="data-termin text-muted">23 marca 2019</td>
                            <td></td>
                            <td className="termin next text-muted">Rozpoczęcie rejestracji i przyjmowania zgłoszeń na wystąpienia ustne lub prezentację plakatu</td>
                        </tr>
                        <tr>
                            <td className="data-termin text-muted "><del>13 maja 2019</del><br/><span className="text-muted"> 24 czerwca 2019</span></td>
                            <td></td>
                            <td className="termin text-muted">Zamknięcie możliwości nadsyłania abstraktów na wystąpienia ustne
                                <br/><span className="text-muted">Termin przedłużony do dnia 24 czerwca !</span></td>
                        </tr>
                        <tr>
                            <td className="data-termin text-muted"><del>24 czerwca 2019</del><br/><span className="data-termin text-muted text-danger"> 15 lipca 2019</span></td>
                            <td></td>
                            <td className="data-termin text-muted">Nadsyłania abstraktów na prezentację plakatu
                            <br/><span className="data-termin text-muted text-muted">Termin przedłużony do dnia 15 lipca 2019 !</span></td>
                        </tr>
                        <tr>
                            <td className="data-termin text-muted">30 czerwca 2019<br/><span className="data-termin text-muted text-danger"> 15 lipca 2019</span></td>
                            <td></td>
                            <td className="data-termin text-muted">Ostatni dzień rejestracji <del>i płatności</del>, w którym obowiązuje niższa opłata konferencyjna<br/>
                                <span className="data-termin text-muted text-danger">Termin przedłużony wnoszenia opłaty konferencyjnej do dnia 15 lipca 2019 !</span></td>
                        </tr>
                        <tr>
                            <td className="data-termin text-muted">15 sierpnia 2019</td>
                            <td></td>
                            <td className="termin text-muted">Zakończenie rejestracji uczestników</td>
                        </tr>
                        <tr>
                            <td className="data-termin next">30 sierpnia 2019</td>
                            <td><span className="circle1 red1"></span><span className="circle2 red2"></span></td>
                            <td className="termin next">Ostateczny termin wnoszenia opłaty konferencyjnej</td>
                        </tr>
                        <tr>
                            <td className="data-termin">13-18 września 2019</td>
                            <td></td>
                            <td className="termin">45. Zjazd Fizyków Polskich w Krakowie</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          <h2>Opłaty konferencyjne</h2>
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12">
                    <table className="table table-striped fee">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Rejestracja do 30.06.2019 <br/><span className="text-danger">Płatność do 15.07.2019</span></th>
                            <th>Rejestracja od 01.07.2019</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="group">Pracownik naukowy</td>
                            <td>1100 zł</td>
                            <td>1200 zł</td>
                        </tr>
                        <tr>
                            <td className="group">Pracownik naukowy będący członkiem PTF</td>
                            <td>1000 zł</td>
                            <td>1100 zł</td>
                        </tr>
                        <tr>
                            <td className="group">Nauczyciel, Doktorant, Student, Uczeń, Emeryt</td>
                            <td>300 zł</td>
                            <td>350 zł</td>
                        </tr>
                        <tr>
                            <td className="group">Nauczyciel, Doktorant, Student, Uczeń, Emeryt, będący członkiem PTF</td>
                            <td>250 zł</td>
                            <td>300 zł</td>
                        </tr>
                        <tr>
                            <td className="group">Osoba towarzysząca</td>
                            <td>400 zł</td>
                            <td>500 zł</td>
                        </tr>
                        <tr>
                            <td className="group">Inny regularny uczestnik Zjazdu</td>
                            <td>1100 zł</td>
                            <td>1200 zł</td>
                        </tr>
                        <tr>
                            <td className="group">Nauczyciele uczestniczący wyłącznie w Konferencji Dydaktycznej (14-15.09.2019)</td>
                            <td>150 zł</td>
                            <td>200 zł</td>
                        </tr>
                        <tr>
                            <td className="group">Nienauczyciele uczestniczący wyłącznie w Konferencji Dydaktycznej" (14-15.09.2019)</td>
                            <td>300 zł</td>
                            <td>350 zł</td>
                        </tr>
                        <tr>
                            <td className="group">Uczestnicy wyłącznie sesji "Fizyka-Przemysł-Innowacje" (16-17.09.2019)</td>
                            <td>600 zł</td>
                            <td>700 zł</td>
                        </tr>

                        </tbody>
                    </table>
                    <p className="info">Opłata konferencyjna zawiera: udział w sesjach naukowych i popularnonaukowych, lunch we wszystkie dni Zjazdu, przerwy kawowe, udział w wycieczkach, koncercie, bankiecie konferencyjnym oraz materiały konferencyjne.<br/>
                    </p>
                    <p className="alert">
                        Podane opłaty konferencyjne nie obejmują kosztów podróży i noclegów.
                    </p>
                </div>
            </div>
            <h2>Płatności</h2>
            <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-8">
                    <p>Opłata konferencyjna powinna być wniesiona przelewem bankowym na konto:</p>
                    <p>
                        Tytuł przelewu bankowego: <b> 45ZFP, NAZWISKO IMIĘ</b><br/>
                        Bank: <b>Bank Handlowy w Warszawie S.A.</b><br/>
                        Właściciel konta: <b>Polskie Towarzystwo Fizyczne, ul. Hoża 69, 00-681 Warszawa</b> <br/>
                        IBAN: <b>PL35 1030 0019 0109 8503 3003 3462</b><br/>
                        SWIFT: <b>CITIPLPX</b><br/>
                    </p>
                    <p className="alert">
                        Uprzejmie przypominamy, że ze względów technicznych nie będzie możliwe wnoszenie opłat w gotówce w trakcie Zjazdu.
                    </p>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4">
                </div>
            </div>
        </div>
      </div>
    </React.Fragment>
  );
};

RegistrationFee.propTypes = {};
